import { Action, createReducer, on } from '@ngrx/store';
import * as StaticActions from '../actions/static.actions';

import { Company, Country, NameIdModel, Product, Region, Terminal } from '@ct/model';
import { informationSource } from './quantity-basis';
import { tradeStatuses } from './trade-statuses';

export const staticFeatureKey = 'static';

export interface State {
  regions: Map<string, Region>;
  countries: Map<string, Country>;
  products: Map<string, Product>;
  terminals: Map<string, Terminal>;
  companies: Map<string, Company>;
  tradeStatuses: Map<string, NameIdModel>;
  vesselTypes: Map<string, NameIdModel>;
  informationSource: Map<string, NameIdModel>;
  vessels: Array<string>;
}

export const initialState: State = {
  regions: new Map(),
  countries: new Map(),
  products: new Map(),
  terminals: new Map(),
  companies: new Map(),
  tradeStatuses,
  vesselTypes: new Map(),
  informationSource,
  vessels: [],
};

const staticReducer = createReducer(
  initialState,
  on(StaticActions.LoadProductsSuccess, (state, { products }) => ({
    ...state,
    products: products.reduce((map, product) => {
      map.set(product.id, product);
      return map;
    }, new Map<string, Product>()),
  })),
  on(StaticActions.LoadCountriesSuccess, (state, { countries }) => ({
    ...state,
    countries: countries.reduce((map, country) => {
      map.set(country.id, country);
      return map;
    }, new Map<string, Country>()),
  })),
  on(StaticActions.LoadTerminalsSuccess, (state, { terminals }) => ({
    ...state,
    terminals: [...terminals]
      .sort((a, b) => a.name.localeCompare(b.name))
      .reduce((map, terminal) => {
        map.set(terminal.id, terminal);
        return map;
      }, new Map<string, Terminal>()),
  })),
  on(StaticActions.LoadRegionsSuccess, (state, { regions }) => ({
    ...state,
    regions: regions.reduce((map, region) => {
      map.set(region.id, region);
      return map;
    }, new Map<string, Region>()),
  })),
  on(StaticActions.LoadCompaniesSuccess, (state, { companies }) => ({
    ...state,
    companies: companies.reduce((map, company) => {
      map.set(company.id, company);
      return map;
    }, new Map<string, Company>()),
  })),
  on(StaticActions.LoadVesselTypesSuccess, (state, { vesselTypes }) => ({ ...state, vesselTypes })),
  on(StaticActions.LoadVesselsSuccess, (state, { vessels }) => ({ ...state, vessels }))
);

export function reducer(state: State | undefined, action: Action) {
  return staticReducer(state, action);
}
